import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/car/carMonthLog/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/car/carMonthLog/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/v4ward/car/carMonthLog/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/car/carMonthLog/submit', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/car/carMonthLog/submit', params, options);
